module.exports = __webpack_public_path__ + "static/media/logo-azapfy.3300ed99.png";